/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.05.2016.
 */

import {
  APPEND_COLLECTION,
  FETCH_COLLECTION,
  FETCH_PACKAGES,
  SEARCH_KEYWORDS,
  SEARCH_RELATED
} from '../../actions/collection/actions-collection';

import {
  FETCH_ASSET,
  FETCH_ASSET_BY_IDS
} from '../../actions/asset/action-asset';

import {
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES
} from '../../actions/favorites/actions-favorites';

import {
  INIT_PROGRAM_GUIDE
} from '../../actions/schedule/actions-schedule';

import {
  ACK_PURCHASE, CANCEL_PURCHASE
} from '../../actions/purchase/actions-purchase';

import {PendingState, SuccessState, ErrorState} from '../../utils';

import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _pickBy from 'lodash/pickBy';
import _intersection from 'lodash/intersection';
import _forIn from 'lodash/forIn';
import _isUndefined from 'lodash/isUndefined';
import _keyBy from 'lodash/keyBy';

/**
 * Normalized asset collection
 *
 * {
 *    1234: {
 *      id: 1234,
 *      title: 'title',
 *      type: 'type'
 *      ...
 *    }
 * }
 *
 * @type {{number}}
 */
const INIT_STATE = {};

export default function (state = INIT_STATE, action) {
  let collectionKeyBy;
  let assetsWithPackages;

  switch (action.type) {

    case PendingState(FETCH_ASSET):

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          _fetchInProgress: true
        }
      };

    case SuccessState(FETCH_ASSET):

      if (_isUndefined(state[action.meta.key])) {

        return {
          ...state,
          [action.meta.key]: {
            ...action.payload,
            _fetchInProgress: false
          }
        };
      }

      return {
        ...state,
        [action.meta.key]: {
          ...action.payload,
          _fetchInProgress: false
        }
      };

    case ErrorState(FETCH_ASSET):

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          _fetchInProgress: false
        }
      };

    case SuccessState(FETCH_ASSET_BY_IDS): {

      return {
        ...state,
        ..._get(action.payload, 'entities.asset', {})
      };
    }

    case SuccessState(SEARCH_KEYWORDS): {

      return {
        ...state,
        ..._get(action.payload, 'entities.asset', {})
      };
    }

    case SuccessState(SEARCH_RELATED): {

      return {
        ...state,
        ..._get(action.payload, 'entities.asset', {})
      };
    }

    case SuccessState(FETCH_COLLECTION):

      collectionKeyBy = _keyBy(action.payload, 'id');

      return {
        ...state,
        ...collectionKeyBy
      };

    case SuccessState(APPEND_COLLECTION):

      collectionKeyBy = _keyBy(action.payload, 'id');

      return {
        ...state,
        ...collectionKeyBy
      };

    case SuccessState(FETCH_PACKAGES):

      collectionKeyBy = _keyBy(action.payload, 'id');

      return {
        ...state,
        ...collectionKeyBy
      };

    case SuccessState(ADD_TO_FAVORITES): {

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          is_favorite: true
        }
      };
    }

    case SuccessState(REMOVE_FROM_FAVORITES): {

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          is_favorite: false
        }
      };
    }

    case SuccessState(INIT_PROGRAM_GUIDE): {
      collectionKeyBy = _keyBy(action.payload, 'id');

      return {
        ...state,
        ...collectionKeyBy
      }
    }

    case SuccessState(ACK_PURCHASE): {
      if (action.payload.offer.type === 'transactional') {

        collectionKeyBy = _pick(state, [action.payload.asset_id]);

        assetsWithPackages = _pickBy(state, (asset) => {

          return _intersection(asset.package_id, [action.payload.asset_id]).length;
        });
      } else {

        collectionKeyBy = _pick(state, action.payload.offer.assets);

        assetsWithPackages = _pickBy(state, (asset) => {

          return _intersection(asset.package_id, action.payload.offer.assets).length;
        });
      }

      _forIn(collectionKeyBy, (value, key) => {

        collectionKeyBy[key] = lh.utils.augmentPersonalData(value);
      });

      _forIn(assetsWithPackages, (value, key) => {

        assetsWithPackages[key] = lh.utils.augmentPersonalData(value);
      });

      return {
        ...state,
        ...collectionKeyBy,
        ...assetsWithPackages
      };
    }

    case SuccessState(CANCEL_PURCHASE): {
      if (action.payload.offer.type === 'transactional') {

        collectionKeyBy = _pick(state, [action.payload.asset_id]);

        assetsWithPackages = _pickBy(state, (asset) => {

          return _intersection(asset.package_id, [action.payload.asset_id]).length;
        });
      } else {

        collectionKeyBy = _pick(state, action.payload.offer.assets);

        assetsWithPackages = _pickBy(state, (asset) => {

          return _intersection(asset.package_id, action.payload.offer.assets).length;
        });
      }

      _forIn(collectionKeyBy, (value, key) => {

        collectionKeyBy[key] = lh.utils.augmentPersonalData(value);
      });

      _forIn(assetsWithPackages, (value, key) => {

        assetsWithPackages[key] = lh.utils.augmentPersonalData(value);
      });

      return {
        ...state,
        ...collectionKeyBy,
        ...assetsWithPackages
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/assets/reducer-assets.js